module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/icon-stats-lg-ffb7d8e4128719a1beadfedc481a9f8f.png";